import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationsCacheKey } from "./constants";
import type { CreateTransformationRequest, Transformation } from "@dashboardApi/apis/dataTransformation/types";
import fetch from "@lib/fetch";

export const createTransformation = reactQueryMutationAdapter(
  appsTransformationsCacheKey,
  async (request: CreateTransformationRequest): Promise<Transformation> => {
    return fetch(
      "/apps/transformations",
      "POST",
      request,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
